import { useTranslation } from 'react-i18next';
import { MapBuilderPopupContainer } from './styled';
import NoFlowControlHeaderSvg from './svgs/no-flow-control-notification-header.svg?react';
import { Button } from 'antd';

interface MapBuilderPopupProps {
  open: boolean;
  onClose: () => void;
}

const NoFlowControlNotificationModal = ({ open, onClose }: MapBuilderPopupProps) => {
  const { t } = useTranslation();
  return (
    <MapBuilderPopupContainer
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={600}
      title={null}
      closeIcon={false}
      closable={false}
      maskClosable={false}
    >
      <div className="modal-header-svg">
        <NoFlowControlHeaderSvg />
      </div>
      <div className="modal-title">{t('noFlowControlNotificationTitle')}</div>
      <div className="modal-subtitle">{t('noFlowControlNotificationSubtitle')}</div>
      <div className="popup-content">
        <ul className="update-list">
          <li>{t('noFlowControlKpisRecalculated')}</li>
          <li>{t('noFlowControlSavingsAdjusted')}</li>
          <li>{t('noFlowControlSensorsDifferent')}</li>
          <li>{t('noFlowControlHistoricalKpis')}</li>
        </ul>
        <div className="closing-message">{t('noFlowControlClosingMessage')}</div>
        <div className="button-container">
          <Button type="primary" onClick={onClose}>
            {t('noFlowControlOkButton')}
          </Button>
        </div>
      </div>
    </MapBuilderPopupContainer>
  );
};

export default NoFlowControlNotificationModal;
